import React from "react";
import defaultStyle from "../../../utils/default";
import mixpanel from "mixpanel-browser";
import { logContentBlockPressEvent } from "../../../utils/events";
import { useAppContext } from './../../../util'

const SocialIcons = ({ icons, color, index, contentBlockId }) => {

  const { userId, pageId } = useAppContext()

  const handleClicked = () => {
    logContentBlockPressEvent(contentBlockId);
    mixpanel.track("Web Link Clicked", {
      Button_type: "social",
      distinct_id: userId,
      stack_id: pageId,
    });
  };
  return (
    <div className="iconContainer" key={index} onClick={handleClicked}>
      {icons.map((icon, i) => {
        if (!icon?.platform || !icon?.accountUrl) {
          return null; // Skip rendering if required properties are missing
        }

        // Construct the URL based on the platform and username
        const socialUrl = getSocialUrl(icon?.platform, icon?.accountUrl);

        return (
          <a
            key={i}
            className="logoIcon"
            style={{
              color: color?.color?.primary || defaultStyle.color.primary,
            }}
            href={socialUrl}
            target="_blank"
            rel="noopener noreferrer" // Added for security
          >
            <i
              className={icon?.icon}
              style={{
                fontSize: "24px",
              }}
            ></i>
          </a>
        );
      })}
    </div>
  );
};

// Function to construct the social media profile URL
function getSocialUrl(platform, accountUrl) {
  const lowercasePlatform = platform.toLowerCase();

  switch (lowercasePlatform) {
    case "facebook":
    case "youtube":
    case "spotify":
    case "twitch":
    case "discord":
    case "linkedin":
      return accountUrl.includes("https")
        ? accountUrl
        : `https://www.${accountUrl}`;
    case "instagram":
      return `https://www.instagram.com/${accountUrl}/?hl=en`;
    case "tiktok":
      return `https://www.tiktok.com/@${accountUrl}`;
    case "pinterest":
      return `https://www.${lowercasePlatform}.com/${accountUrl}`;
    case "snapchat":
      return `https://www.${lowercasePlatform}.com/add/${accountUrl}`;
    case "x":
      return `https://www.${lowercasePlatform}.com/${accountUrl}`;
    default:
      // If the platform is not recognized, perform a Google search
      return accountUrl.includes("https")
        ? accountUrl
        : `https://www.google.com/search?q=${encodeURIComponent(accountUrl)}`;
  }
}

export default SocialIcons;
